import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Tonality } from '@dsny/dsny-component-library'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const largeDesktopQuery = createResponsiveBreakpointQuery('largeDesktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.searchLargeDesktopUp
})

const smallDesktopQuery = createResponsiveBreakpointQuery('smallDesktopUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.searchSmallDesktopUp
})

const mobileQuery = createResponsiveBreakpointQuery('mobileDown', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.mobileDown
})

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: flex-start;
  overflow-y: auto;
  padding: 24px 16px 0;

  @media ${largeDesktopQuery} {
    padding-left: 24px;
  }
`

export const HeaderRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  gap: 16px;
`

export const TitleText = styled(Tonality.UIText)`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.neutralW90};

  @media ${smallDesktopQuery} {
    font-size: 30px;
  }
`

export const ClearButtonDesktop = styled(Tonality.Button)`
  width: 160px;
  font-size: 12px;
  border: none;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white0};
  background: ${({ theme }) => theme.colors.neutralW30};

  @media ${mobileQuery} {
    margin-left: auto;
  }
`

export const ListItemLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-bottom: 16px;
  &:focus {
    outline: none;
  }
`

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
`

export const Spacer = styled.div`
  flex: none;
  height: 32px; /* h-8 */
  width: 100%;
`

export const EmptyState = styled.div`
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  height: 50svh;
`

export const EmptyIconWrapper = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 28px;
  background: ${({ theme }) => theme.colors.player20};
  display: flex;
  align-items: center;
  justify-content: center;
`
